import React from "react";

import ErrorBoundary from "shared/components/ErrorBoundary";
import LoadingError from "shared/components/LoadingError";

import "./PageErrorCatcher.scss";

const PageErrorCatcher = (props) => (
	<ErrorBoundary
		renderFallback={() => (
			<LoadingError
				className="page-error-catcher"
				onReload={() => window.location.reload()}
				show
			/>
		)}
		{...props}
	/>
);

export default PageErrorCatcher;



// WEBPACK FOOTER //
// ./src/routers/shared/components/PageErrorCatcher/index.jsx